import React from 'react';
import DemographicForm from '../Forms/DemographicForm.jsx'
import { translate } from '../translations/translations.js';
import { translateCountry } from '../translations/countryTranslations.js';

class PartialDemographicForm extends DemographicForm {


  render() {
    const { countries, language } = this.props;
    const { name, age, gender, originCountry, } = this.state;

    return (
        <form onSubmit={this.handleSubmit}>
          <header className='form-header'>
            <h1>
              {translate('demographicPrompt', language)}
            </h1>
          </header>
          <div className="form-container">
            <div className='input-field-regular'>
              <input 
                type="number"
                name="age"
                value={age}
                onChange={this.handleChange}
                placeholder={translate('agePlaceholder', language)}
                min="0"
                required
              />
            </div> 
            <select name="gender" className='input-field-regular' value={gender} onChange={this.handleChange} required>
              <option value="">{translate('genderPlaceholder', language)}</option>
              <option value="male">{translate('male', language)}</option>
              <option value="female">{translate('female', language)}</option>
              <option value="other">{translate('other', language)}</option>
            </select>
            <div>
              <select name="originCountry" className='input-field-regular' value={originCountry} onChange={this.handleChange} required>
                <option value="" disabled>{translate('countryPlaceholder', language)}</option>
                {[...countries]
                  .sort((a, b) => {
                    const nameA = translateCountry(a.country_acronym, language).toLowerCase();
                    const nameB = translateCountry(b.country_acronym, language).toLowerCase();
                    return nameA.localeCompare(nameB);
                  })
                  .map((country) => (
                    <option key={country.country_id} value={country.country_id}>
                      {translateCountry(country.country_acronym, language)}
                    </option>
                ))}
              </select>
            </div>
          </div>
          <button type="submit">{translate('submit', language)}</button>
        </form>
    );
  }
}

export default PartialDemographicForm;
